import React from 'react';
import './haveQuestion.css';
import { Link } from 'react-router-dom';
import SectionName from '../section-name/section-name';
// import { Link } from "react-scroll";


function HaveQuestion(){
    return( 
        <div id='contact'>
        <SectionName name="Contact Us"/>
        <div className="q_box">
            <div className="inner-container" data-aos="fade-down">
                <h2>Have a Question?</h2>
                <p>Our client support team is looking forward to help you out 100% free</p>
                <div>
                    <Link to="https://calendly.com/buyersgalaxy/30min?month=2024-11" target='_blank' className="btn1">Book A Call</Link>
                    <Link to="/contact" className="btn2">Contact Us</Link>
                </div>
            </div> 
        </div>
        </div>
    );
} 
export default HaveQuestion;
